export default __webpack_public_path__ + "static/media/nv9.2bc56435.PNG";